<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>每日读片</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
      <div class="conten">
          <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
                 每日读片
            </template>
             <p class="text"> 每日读片的界面展示为日历形式，用户可提前进入操作当日（非当日数据不可操作）的读片事件，包括添加影像、病例、附件，在读片时，也可进行“互视客户端”的开启。</p>
            <img src="../../../../static/image/28.png"/>
            <P>点击【新建事件】，设定“重复周期”为“按周”，依次选择重复日、事件日期范围、事件时间，最后点击【确定】，完成新增。</P>
            <img src="../../../../static/image/29.png"/>
            <P><b class="blod">注：“重复周期”为“按周”时，选定的“周一周二…周日，在事件日期范围内，必需有1次满足，否则，将无法新增。</b></P>
            <P>点击【新建事件】，在设定“重复周期”为“无”，依次选择事件日期范围、事件时间，最后点击【确定】，完成新增。</P>
              <img src="../../../../static/image/30.png"/>
              <P>点击【批量删除】，可删除指定时间内未开始的事件。</P>
          </el-collapse-item>
          <el-collapse-item title="进入会议影像/病例/附件添加">
            <p class="text">用户进入当日读片会议后，可以在影像模块的文本输入框内输入“病案号”、“检查号”进行影像数据的精确查询；也可在点击后<b><img  class="littleImg"  src="../../../../static/image/68.png"/></b>，进入影像库，如图-影像库，进行自由选择。</p>
            <P class="text">在影像库中，勾选对应记录，点击【加入读片队列】，即可完成影像数据添加。</P>
            <P class="text"><b class="titleBar">注：影像数据添加成功后可进行影像阅片、申请单查看等操作，不支持删除。</b></P>
            <div><img src="../../../../static/image/10.png"/></div>
            <P style="margin-left:35%">影像库</P>
            <P class="text">用户可以在病例模块的文本输入框内输入“病例名称”进行病例数据的模糊查询；也可在点击后<b><img  class="littleImg"  src="../../../../static/image/68.png"/></b>，进入病例库，进行自由选择。</P>
            <P class="text">在病例库中，勾选对应记录，点击【加入读片队列】，即可完成病例数据添加。</P>
            <P class="text"><b class="titleBar">注：病例数据添加成功后可查看病例详情，不支持删除。</b></P>
            <div><img src="../../../../static/image/23.png"/></div>
            <P style="margin-left:35%">病例库</P>
            <h1 class="titleBar">“文档类型”添加</h1>
            <P class="text">用户点击左侧按钮【从我的电脑选择】，弹出文件选择框，选择指定文件后，点击“确定”后，完成添加（只支持单个文件的添加，并且文件大小小于30M）。</P>
            <h1 class="titleBar">“图片类型”添加</h1>
            <P class="text">用户点击左侧按钮【从我的电脑选择】，弹出文件选择框，选择指定文件后，点击“确定”后，完成添加（只支持单个文件的添加，并且文件大小小于3M）。</P>
            <P class="text"><b class="titleBar">注：附件数据添加成功后可在线预览，不支持删除。</b></P>
         </el-collapse-item>
        </el-collapse>
      </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
  .rightContent
    position: relative
    float: right
    overflow:auto
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
  .conten
    padding: 25px 0px 25px 30px
  img
    width:80%
   .littleImg
      width:30px
      vertical-align:middle
  .titleBar
     color:#000
     font-weight:bolder
   .text
     color:#555
     line-height: 25px
     text-indent:2em
  .blod
    font-weight:bolder
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px

</style>



// WEBPACK FOOTER //
// DailyReading.vue?fa38c624